/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_VoicesInputs */

const en_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voices`)
};

const fr_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voix`)
};

const de_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimmen`)
};

const it_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voci`)
};

const ru_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Голоса`)
};

const es_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voces`)
};

const zh_cn2_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`声音`)
};

const ja_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`声`)
};

const hi_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवाज़ें`)
};

const pt_pt2_options_quicktools_voices = /** @type {(inputs: Options_Quicktools_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vozes`)
};

/**
* | output |
* | --- |
* | "Voices" |
*
* @param {Options_Quicktools_VoicesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_voices = /** @type {((inputs?: Options_Quicktools_VoicesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_VoicesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_quicktools_voices(inputs)
	if (locale === "de") return de_options_quicktools_voices(inputs)
	if (locale === "it") return it_options_quicktools_voices(inputs)
	if (locale === "ru") return ru_options_quicktools_voices(inputs)
	if (locale === "es") return es_options_quicktools_voices(inputs)
	if (locale === "zh-CN") return zh_cn2_options_quicktools_voices(inputs)
	if (locale === "ja") return ja_options_quicktools_voices(inputs)
	if (locale === "hi") return hi_options_quicktools_voices(inputs)
	if (locale === "pt-PT") return pt_pt2_options_quicktools_voices(inputs)
	return en_options_quicktools_voices(inputs)
});